import axios from 'axios'
import { getServerHost } from '@/utils/host'
import { encryptionParameters } from '@/utils/httpSign'
import { getClientVersion } from '@/utils/request_helper'
import { appendApiUrl } from '@/utils/request'

export async function apiInit(country, context) {
  try {
    const { req } = context
    const ssrLocationParams = {
      host: req?.headers.host,
      url: req?.url,
      health_checks: req?.headers?.['is-health-examination'] || '',
    }

    const response = await axios({
      method: 'post',
      url: appendApiUrl('/init'),
      baseURL: getServerHost(ssrLocationParams),
      timeout: 5000,
      data: {
        country,
      },
      headers: {
        'X-Version': getClientVersion(),
        'x-forwarded-for':
          req?.headers?.['x-client-for'] ||
          req?.headers?.['x-forwarded-for'] ||
          req?.headers?.['x-real-ip'] ||
          '',
        'x-client-for': req?.headers?.['x-client-for'] || '',
        ...encryptionParameters(
          {
            url: appendApiUrl('/init'),
            data: JSON.stringify({ country }),
          },
          'init'
        ),
      },
    })
    /* eslint-disable */
    const parameterLogs = {
      headers: response.config.headers,
      baseURL: response.config.baseURL,
      contextHeaders: context.req.headers,
    }
    console.log(
      `/init===============================================================>>> 接口参数请求的headers`,
      parameterLogs
    )

    const { status, data = {} } = response || {}
    const { status: code, data: res } = data
    /* eslint-disable */
    // console.log('init api response ===>>>', response)
    if (status === 200 && code === 200) {
      const apiSign = res || {}
      // 响应时间
      const responseTime = new Date().getTime()
      apiSign.responseTime = responseTime
      /* eslint-disable */
      // console.log('init api res ===>>>', res)
      return apiSign || {}
    }
    return {}
  } catch (err) {
    const time = new Date().toLocaleString()
    const req = context?.req
    let url = ''
    let headers = ''
    let body = ''
    let ips = ''
    if (req) {
      url = req.url
      ips = req.ips
      body = JSON.stringify(req.body)
      headers = JSON.stringify(req.headers)
    }
    /* eslint-disable */
    console.log('apiInit ===>>>', time, url, ips, body, headers, '\n', err)
  }
}
